import React, { useEffect, useState, useRef } from "react";
import Button from '@mui/material/Button';
import TextField from '@mui/material/TextField';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';

const WorkInProgress = ({ open, handleClose }) => {

  /*const definition*/
  const [loading, setLoading] = useState(false);
  const [namelocal, setNameLocal] = useState("");
  const [emaillocal, setEmailLocal] = useState("");
  const [citylocal, setCityLocal] = useState("");
  const [countrylocal, setCountryLocal] = useState("");
  const [categorylocal, setCategoryLocal] = useState("");
  const [idclientlocal, setID_ClientLocal] = useState("");
  const [biolocal,setBioLocal] = useState("");
  const [password,setPassword] = useState("");
  const [newpassword,setNewPassword] = useState("");


  /*clean up variables*/


  return (
    <Dialog
      open={open}
      onClose={(event, reason) => {
        if (reason !== 'backdropClick' && reason !== 'escapeKeyDown') {
          handleClose();
        }
      }}
      ModalProps={{
        disableEnforceFocus: true,
      }}
      
    >
      <DialogTitle>Coming Soon...</DialogTitle>
      <DialogContent>
        <DialogContentText>
          We are working on this section of the platform. Please come back later.
        </DialogContentText>
        <DialogContentText>
          If you have suggestions about network connections and collaborative ways of sharing knowledge, please contact us.
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button onClick={handleClose}>Ok, Thanks</Button>
        
      </DialogActions>
    </Dialog>
  );
};

export default WorkInProgress;